<template>
<div class="about">
	<PagesHeading />
	<div class="container">
		<div class="profile">
			<img src="/images/logo.png" class="img-fluid d-block mx-auto my-4" style="width:20%">
			<p class="text-center text-muted">{{$t('AboutPage.company-profile-text')}}</p>
		</div>
	</div>
	<div class="quality-policy my-5">
		<div class="row">
			<div class=" col-sm-4 col-12 quality-title">
				<img src="/images/quality.png" class="d-block mx-auto">
				<h4 class="text-center">{{$t('AboutPage.quality-policy') }}</h4>
			</div>
			<div class=" col-sm-7 col-12 quality-text ">
				<P class="text-muted container">{{$t('AboutPage.quality-policy-text') }}</P>
			</div>
		</div>
	</div>
	<div class="container mb-5">
		<h2 class="text-center mb-5">{{$t('AboutPage.products') }}</h2>
		<div class="row">
			<div class="col-sm-4 d-flex align-items-end justify-content-center"><p>{{$t('AboutPage.natural-flavors') }}</p></div>
			<div class="col-sm-8">
				<div class="row">
					<div class="col-sm-4 col-12 set-bottom">
						<img class="d-block mx-auto" src="/images/flavors/salt-and-vineger.png" style="width:78%; height:auto">
						<div>
							<div class="separator"></div>
							<p class="text-center">{{$t('AboutPage.weight-50') }}</p>
						</div>
					</div>
					<div class="col-sm-4 col-12  set-bottom">
						<img class="d-block mx-auto" src="/images/flavors/salt.png" style="width:90%; height:auto">
						<div>
							<div class="separator"></div>
							<p class="text-center">{{$t('AboutPage.weight-80') }}</p>
						</div>
					</div>
					<div class="col-sm-4 col-12  set-bottom">
						<img class="d-block mx-auto" src="/images/flavors/stroganoff.png" style="width:70%; height:auto">
						<div>
							<div class="separator"></div>
							<p class="text-center">{{$t('AboutPage.weight-20') }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	<div class="container my-5">
		<h2 class="text-center mb-4">{{$t('AboutPage.flavors') }}</h2>
			<div class="row">
				<div class="col-sm-3 col-12">
					<img class="d-block mx-auto" src="/images/flavors/salt-and-vineger.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/vinegar.png">
						<span class="text-muted">{{$t('AboutPage.salt-and-vinegar') }}</span>
					</div>
				</div>
				<div class="col-sm-3 col-12">
					<img class="d-block mx-auto" src="/images/flavors/barbecue.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/sausage.png">
						<span class="text-muted">{{$t('AboutPage.barbecue') }}</span>
					</div>
				</div>
				<div class="col-sm-3 col-12">
					<img class="d-block mx-auto" src="/images/flavors/salt.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/salt.png">
						<span class="text-muted">{{$t('AboutPage.salt') }}</span>
					</div>
				</div>
				<div class="col-sm-3 col-12">
					<img class="d-block mx-auto" src="/images/flavors/ketchep.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/tomato-sauce.png">
						<span class="text-muted">{{$t('AboutPage.ketchup') }}</span>
					</div>
				</div>
				<div class="col-sm-3 col-12 mt-4">
					<img class="d-block mx-auto" src="/images/flavors/hot-pepper.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/chili-pepper.png">
						<span class="text-muted">{{$t('AboutPage.hot-pepper') }}</span>
					</div>
				</div>
				<div class="col-sm-3 col-12 mt-4">
					<img class="d-block mx-auto" src="/images/flavors/chesse.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/cheese.png">
						<span class="text-muted">{{$t('AboutPage.french-cheese') }}</span>
					</div>
				</div>
				<div class="col-sm-3 col-12 mt-4">
					<img class="d-block mx-auto" src="/images/flavors/stroganoff.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/borscht.png">
						<span class="text-muted">{{$t('AboutPage.russian-flavor') }}</span>
					</div>
				</div>
				<div class="col-sm-3 col-12 mt-4">
					<img class="d-block mx-auto" src="/images/flavors/garlic-and-onion.png" style="width:90%; height:auto">
					<div class="mt-3 text-center">
						<img src="/images/flavorsIcons/onion.png">
						<span class="text-muted">{{$t('AboutPage.garlic-and-onion') }}</span>
					</div>
				</div>
			</div>
	</div>
	<div class="container my-5">
		<h2 class="text-center mb-4">{{$t('AboutPage.potatoes') }}</h2>
		<div class="row">
			<div class="col-md-6 col-lg-4 col-12">
				<div class="card potates-card mx-auto c2 my-3 block bounceIn animated" style="background-image:url(/images/type1.jpg); width:18rem">
					<div class="overlay">
						<div class="card-body h-40 c2-body">
							<h3 class="card-title text-center text-white font-weight-bold">{{$t('AboutPage.potetos-ageria') }}</h3> 
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6 col-lg-4 col-12">
				<div class="card potates-card mx-auto c2 my-3 block bounceIn animated" style="background-image:url(/images/type2.jpg); width:18rem">
					<div class="overlay">
						<div class="card-body h-40 c2-body">
							<h3 class="card-title text-center text-white font-weight-bold">{{$t('AboutPage.potetos-jelly') }}</h3> 
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6 col-lg-4 col-12">
				<div class="card potates-card mx-auto c2 my-3 block bounceIn animated" style="background-image:url(/images/type3.jpg); width:18rem">
					<div class="overlay">
						<div class="card-body h-40 c2-body">
							<h3 class="card-title text-center text-white font-weight-bold">{{$t('AboutPage.potetos-hormuz') }}</h3> 
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="container">
		<h2 class="text-center mb-5">{{$t('AboutPage.production-stages') }}</h2>
		<ul class="timeline">
			<li>
				<div class="timeline-badge"><img src="/images/stage-1.png"></div>
				<div class="timeline-panel">
					<div class="timeline-heading">
						<h4 class="timeline-title">{{$t('AboutPage.production-stage-1') }}</h4>
					</div>
					<div class="timeline-body">
						<p>{{$t('AboutPage.production-stage-text-1') }}</p>
					</div>
				</div>
			</li>
			<li class="timeline-inverted">
				<div class="timeline-badge">
					<img src="/images/stage-2.png">
				</div>	
				<div class="timeline-panel">
					<div class="timeline-heading">
						<h4 class="timeline-title">{{$t('AboutPage.production-stage-2') }}</h4>
					</div>
					<div class="timeline-body">
						<p>{{$t('AboutPage.production-stage-text-2') }}</p>
					</div>
				</div>
			</li>
			
			<li>
				<div class="timeline-badge">
						<img src="/images/stage-3.png">
					</div>
				<div class="timeline-panel">
					<div class="timeline-heading">
						<h4 class="timeline-title">{{$t('AboutPage.production-stage-3') }}</h4>
					</div>
					<div class="timeline-body">
						<p>{{$t('AboutPage.production-stage-text-3') }}</p>
					</div>
				</div>
			</li>
				
			<li class="timeline-inverted">
				<div class="timeline-badge">
					<img src="/images/stage-4.png">
				</div>
				<div class="timeline-panel">
					<div class="timeline-heading">
						<h4 class="timeline-title">{{$t('AboutPage.production-stage-4') }}</h4>
					</div>
					<div class="timeline-body">
						<p>{{$t('AboutPage.production-stage-text-4') }}</p>
					</div>
				</div>
			</li>
			<li>
				<div class="timeline-badge">
					<img src="/images/stage-5.png">
				</div>
				<div class="timeline-panel">
					<div class="timeline-heading">
						<h4 class="timeline-title">{{$t('AboutPage.production-stage-5') }}</h4>
					</div>
					<div class="timeline-body">
						<p>{{$t('AboutPage.production-stage-text-5') }}</p>
					</div>
				</div>
			</li>
			<li class="timeline-inverted">
				<div class="timeline-badge">
					<img  src="/images/stage-6.png">
				</div>
				<div class="timeline-panel">
					<div class="timeline-heading">
						<h4 class="timeline-title">{{$t('AboutPage.production-stage-6') }}</h4>
					</div>
					<div class="timeline-body">
						<p>{{$t('AboutPage.production-stage-text-6') }}</p>
					</div>
				</div>
			</li>
			<li>
				<div class="timeline-badge">
					<img src="/images/stage-7.png">
				</div>
				<div class="timeline-panel">
					<div class="timeline-heading">
						<h4 class="timeline-title">{{$t('AboutPage.production-stage-7') }}</h4>
					</div>
					<div class="timeline-body">
						<p>{{$t('AboutPage.production-stage-text-7')}}</p>
					</div>
				</div>
			</li>
		</ul>
	</div>
</div>
</template>
<script>
import PagesHeading from '@/components/PagesHeading.vue';
export default {
	components: {
		PagesHeading
	}
}
</script>
<style scoped>
body {
	background-color: #fff;
}

.quality-policy {
	box-shadow:-3px 2px 8px rgba(0, 0, 0, 0.12);
	overflow: hidden;
}

.quality-title {
	background-color: #FC9F2C;
	padding: 2%;
}

.quality-title h4 {
	font-weight: bold;
	color: #fff;
	margin-top: 15px;
}

.quality-text {
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 3%;
}

h2 {
	color: #FC9F2C;
}

.separator {
	border-top: 2px solid #FC9F2C;
	width: 100%;
	display: inline-block;
}

/* timeline style */
.timeline {
	list-style: none;
	padding: 20px 0 20px;
	position: relative;
}

.timeline:before {
	top: 0;
	bottom: 0;
	position: absolute;
	content: " ";
	width: 3px;
	background-color: #eeeeee;
	left: 50%;
	margin-left: -1.5px;
}

.timeline > li {
	margin-bottom: 20px;
	position: relative;
}

.timeline > li:before,
.timeline > li:after {
	content: " ";
	display: table;
}

.timeline > li:after {
	clear: both;
}

.timeline > li:before,
.timeline > li:after {
	content: " ";
	display: table;
}

.timeline > li:after {
	clear: both;
}

.timeline > li > .timeline-panel {
	width: 50%;
	float: left;
	border: 1px solid #d4d4d4;
	border-radius: 2px;
	padding: 20px;
	position: relative;
	-webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
	box-shadow: 0 1px 6px rgba(0, 0, 0, 0.175);
}

.timeline > li.timeline-inverted + li:not(.timeline-inverted),
.timeline > li:not(.timeline-inverted) + li.timeline-inverted {
	margin-top: -40px;
}

.timeline > li:not(.timeline-inverted) {
	padding-right:90px;
}

.timeline > li.timeline-inverted {
	padding-left: 90px;
}

.timeline > li > .timeline-panel:before {
	position: absolute;
	top: 26px;
	right: -15px;
	display: inline-block;
	border-top: 15px solid transparent;
	border-left: 15px solid #ccc;
	border-right: 0 solid #ccc;
	border-bottom: 15px solid transparent;
	content: " ";
}

.timeline > li > .timeline-panel:after {
	position: absolute;
	top: 27px;
	right: -14px;
	display: inline-block;
	border-top: 14px solid transparent;
	border-left: 14px solid #fff;
	border-right: 0 solid #fff;
	border-bottom: 14px solid transparent;
	content: " ";
}

.timeline > li > .timeline-badge {
	color: #fff;
	width: 50px;
	height: 50px;
	line-height: 50px;
	font-size: 1.4em;
	text-align: center;
	position: absolute;
	top: 16px;
	left: 50%;
	margin-left: -25px;
	background-color: #fc9f2c;
	z-index: 100;
	border-top-right-radius: 30%;
	border-top-left-radius: 30%;
	border-bottom-right-radius: 30%;
	border-bottom-left-radius: 30%;
}

.timeline > li.timeline-inverted > .timeline-panel {
	float: right;
}

.timeline > li.timeline-inverted > .timeline-panel:before {
	border-left-width: 0;
	border-right-width: 15px;
	left: -15px;
	right: auto;
}

.timeline > li.timeline-inverted > .timeline-panel:after {
	border-left-width: 0;
	border-right-width: 14px;
	left: -14px;
	right: auto;
}

.timeline-badge.primary {
	background-color: #2e6da4 !important;
}

.timeline-badge.success {
	background-color: #3f903f !important;
}

.timeline-badge.warning {
	background-color: #f0ad4e !important;
}

.timeline-badge.danger {
	background-color: #d9534f !important;
}

.timeline-badge.info {
	background-color: #5bc0de !important;
}

.timeline-title {
	margin-top: 0;
	color: inherit;
	color: #fc9f2c;
}

.timeline-body > p,
.timeline-body > ul {
	margin-bottom: 0;
}

.timeline-body > p + p {
	margin-top: 5px;
}

h3.card-title {
	box-shadow: none;
	padding-bottom: 0;
}

.potates-card {
	height: 22vh;
	background-size: cover;
	border-radius: 40%;
	position: relative;
}

.potates-card:hover > .overlay:after {
	content: "";
	display: block;
	height: 100%;
	width: 100%;
	opacity: 0;
	background: rgba(0,0,0,.5);
	-moz-transition: all 1s;
	-webkit-transition: all 1s;
	transition: all 1s;
	top: 0;
	left: 0;
	position: absolute;
	border-radius: 40%;
}

.potates-card:hover > .overlay:hover:after {
	opacity: 1;
}

.potates-card h3 {
	display: none;
}

.potates-card:hover .overlay h3 {
	position: relative;
	display: flex;
	z-index: 1;
	justify-content: center;
	align-items: center;
	-moz-transition: all 1s;
	-webkit-transition: all 1s;
	transition: all 1s;
}

html[dir='rtl'] .quality-text {
	text-align: right;
}

html[dir='rtl'] .timeline-panel {
	text-align: right;
}

@media (max-width: 767px) {
	ul.timeline:before {
		left: 40px;
	}

	ul.timeline > li > .timeline-panel {
		width: calc(100% - 90px);
		width: -moz-calc(100% - 90px);
		width: -webkit-calc(100% - 90px);
	}

	ul.timeline > li > .timeline-badge {
		left: 15px;
		margin-left: 0;
		top: 16px;
		z-index: 0;
	}

	ul.timeline > li > .timeline-panel {
		float: right;
	}

	ul.timeline > li > .timeline-panel:before {
		border-left-width: 0;
		border-right-width: 15px;
		left: -15px;
		right: auto;
	}

	ul.timeline > li > .timeline-panel:after {
		border-left-width: 0;
		border-right-width: 14px;
		left: -14px;
		right: auto;
	}

	.timeline > li.timeline-inverted + li:not(.timeline-inverted),
	.timeline > li:not(.timeline-inverted) + li.timeline-inverted {
		margin-top: 0;
	}

	.timeline > li.timeline-inverted {
		padding-left: 0;
		padding-right: 40px;
	}
	
	@media(max-width : 767px) {
		.timeline > li.timeline-inverted {
			padding-right: 10px !important;
		}

		.timeline > li:not(.timeline-inverted) {
			padding-right:10px !important;
		}
	}
}

.set-bottom {
	display: flex;
	flex-flow: column;
	justify-content: flex-end;
}
</style>